export default (callback, wait: number) => {
	let timeout: ReturnType<typeof setTimeout>;
	return (...args): void => {
		clearTimeout(timeout);
		timeout = setTimeout(() => callback(...args), wait);
	};
};
